package one.devsbox.www.ui.devices.detail

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.graphics.Color
import one.devsbox.www.io.Repository
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.LocalPreferencesProvider
import one.devsbox.www.provider.PreferencesProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.provider.LocalOverlayProvider
import one.devsbox.www.provider.OverlayProvider
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class DeviceDCtx private constructor(
    val vm: DeviceDVM,
    val nav: Navigation,
    val args: ArgsId,
    val me: MeProvider,
    val prefs: PreferencesProvider,
    val overlay: OverlayProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color,
    val colorErrorContainer: Color
) {
    val action get() = vm.action
    val deviceActions = FeatureDeviceActions()

    companion object {
        @Composable
        fun get(): DeviceDCtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val me = LocalMeProvider.current
            val prefs = LocalPreferencesProvider.current
            val overlay = LocalOverlayProvider.current
            val vm = nav.viewModel(DeviceDVM::class)
            val colorPrimary = MaterialTheme.colorScheme.primaryContainer
            val colorSecondary = MaterialTheme.colorScheme.secondaryContainer
            val colorError = MaterialTheme.colorScheme.errorContainer
            return remember(args.id) {
                DeviceDCtx(
                    vm, nav, args, me, prefs, overlay,
                    colorPrimary, colorSecondary, colorError
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }
}

class FeatureDeviceActions {
    var showDeviceActions by mutableStateOf(false)

    var isRebooting by mutableStateOf(false)
    var rebootStatus by mutableStateOf<String?>(null)
    var isRebootEnabled by mutableStateOf(true)

    var isUpdatingWww by mutableStateOf(false)
    var updateWwwStatus by mutableStateOf<String?>(null)
    var isUpdateWwwEnabled by mutableStateOf(true)

    var isUpdatingRuntime by mutableStateOf(false)
    var updateRuntimeStatus by mutableStateOf<String?>(null)
    var isUpdateRuntimeEnabled by mutableStateOf(true)

    fun open() {
        isRebooting = false
        rebootStatus = null
        isRebootEnabled = true

        isUpdatingWww = false
        updateWwwStatus = null
        isUpdateWwwEnabled = true

        isUpdatingRuntime = false
        updateRuntimeStatus = null
        isUpdateRuntimeEnabled = true

        showDeviceActions = true
    }

    fun close() {
        showDeviceActions = false
    }

    suspend fun reboot(deviceId: Long) {
        isRebooting = true
        rebootStatus = null
        runCatching {
            Repository.ads.device.reboot(deviceId)
        }.onSuccess {
            isRebooting = false
            isRebootEnabled = false
            rebootStatus = "Reboot is queued"
        }.onFailure {
            isRebooting = false
            rebootStatus = it.message ?: "Failed to reboot"
        }
    }

    suspend fun updateWww(deviceId: Long) {
        isUpdatingWww = true
        updateWwwStatus = null
        runCatching {
            Repository.ads.device.updateWww(deviceId)
        }.onSuccess {
            isUpdatingWww = false
            isUpdateWwwEnabled = false
            updateWwwStatus = "Update is queued is pecessing"
        }.onFailure {
            isUpdatingWww = false
            updateWwwStatus = it.message ?: "Failed to update WWW"
        }
    }

    suspend fun updateRuntime(deviceId: Long) {
        isUpdatingRuntime = true
        updateRuntimeStatus = null
        runCatching {
            Repository.ads.device.updateRuntime(deviceId)
        }.onSuccess {
            isUpdatingRuntime = false
            isUpdateRuntimeEnabled = false
            updateRuntimeStatus = "Update is queued is pecessing"
        }.onFailure {
            isUpdatingRuntime = false
            updateRuntimeStatus = it.message ?: "Failed to update runtime"
        }
    }
}
